import { getComparePageBySlug } from "@/app/seo-compare";
import { CompareLayout } from "./CompareLayout";

export default function HotlineVsMcp() {
  const page = getComparePageBySlug("hotline-vs-mcp");
  if (!page) return null;
  return <CompareLayout page={page} />;
}
